// extracted by mini-css-extract-plugin
export default {"header":"LibertyChangePageButton_header__N2rbn"};